var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	26580: () => (loadSingletonVersion("default", "rxjs", false, [4,7,8,2], () => (__webpack_require__.e("node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 63228))))))),
	31257: () => (loadStrictSingletonVersion("default", "@angular/core", false, [4,22,1,7], () => (__webpack_require__.e("node_modules_pnpm_angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_8_2_zone_js_0_16_3_node-0f403b").then(() => (() => (__webpack_require__(/*! @angular/core */ 80731))))))),
	46552: () => (loadSingletonVersion("default", "rxjs/operators", false, [4,7,8,2], () => (__webpack_require__.e("node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 18530))))))),
	1469: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [4,22,1,7], () => (__webpack_require__.e("node_modules_pnpm_angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_8_2_zone_js_0_16_3_node-1926810").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 20320))))))),
	41861: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [4,22,1,7], () => (__webpack_require__.e("node_modules_pnpm_angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_8_2_zone_js_0_16_3_node-d0573c0").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 13288))))))),
	41144: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [4,22,1,7], () => (__webpack_require__.e("node_modules_pnpm_angular_common_22_1_7__angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_-e947c31").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 30169))))))),
	81874: () => (loadStrictSingletonVersion("default", "@angular/common", false, [4,22,1,7], () => (__webpack_require__.e("node_modules_pnpm_angular_common_22_1_7__angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_-f24fa01").then(() => (() => (__webpack_require__(/*! @angular/common */ 54834))))))),
	2649: () => (loadStrictSingletonVersion("default", "@angular/router", false, [4,22,1,7], () => (__webpack_require__.e("node_modules_pnpm_angular_router_22_1_7__angular_common_22_1_7__angular_core_22_1_7__angular_-5036dc1").then(() => (() => (__webpack_require__(/*! @angular/router */ 94683))))))),
	36557: () => (loadStrictSingletonVersion("default", "@ngrx/store", false, [4,22,0,1], () => (__webpack_require__.e("node_modules_pnpm_ngrx_store_22_0_1__angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_8_2_-ae85881").then(() => (() => (__webpack_require__(/*! @ngrx/store */ 45519))))))),
	73150: () => (loadSingletonVersion("default", "@deliverysolutions/shared-models", false, [7,3,0,0,,"beta",11], () => (__webpack_require__.e("node_modules_pnpm_deliverysolutions_shared-models_3_0_0-beta_11_fc25e587a0f248014b3015c5dd7cf-1c084a1").then(() => (() => (__webpack_require__(/*! @deliverysolutions/shared-models */ 71504))))))),
	73923: () => (loadStrictSingletonVersion("default", "@auth0/auth0-angular", false, [4,2,2,3], () => (__webpack_require__.e("node_modules_pnpm_auth0_auth0-angular_2_2_3__angular_common_22_1_7__angular_core_22_1_7__angu-95c9431").then(() => (() => (__webpack_require__(/*! @auth0/auth0-angular */ 10876))))))),
	89778: () => (loadStrictSingletonVersion("default", "@angular/service-worker", false, [4,22,1,7], () => (__webpack_require__.e("node_modules_pnpm_angular_service-worker_22_1_7__angular_core_22_1_7__angular_compiler_22_1_7-24bb4d1").then(() => (() => (__webpack_require__(/*! @angular/service-worker */ 97493))))))),
	62333: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", false, [4,22,1,7], () => (__webpack_require__.e("node_modules_pnpm_angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_8_2_zone_js_0_16_3_node-b66ca31").then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 29925)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"node_modules_pnpm_angular_common_22_1_7__angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_-e947c30": [
		26580,
		31257,
		46552
	],
	"node_modules_pnpm_angular_common_22_1_7__angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_-f24fa00": [
		26580,
		31257
	],
	"node_modules_pnpm_angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_8_2_zone_js_0_16_3_node-b66ca30": [
		1469,
		26580,
		41861,
		46552
	],
	"node_modules_pnpm_angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_8_2_zone_js_0_16_3_node-0f403b": [
		1469,
		26580,
		41861,
		46552
	],
	"node_modules_pnpm_angular_router_22_1_7__angular_common_22_1_7__angular_core_22_1_7__angular_-5036dc0": [
		26580,
		31257,
		41144,
		46552,
		81874
	],
	"node_modules_pnpm_angular_service-worker_22_1_7__angular_core_22_1_7__angular_compiler_22_1_7-24bb4d0": [
		26580,
		31257,
		46552
	],
	"node_modules_pnpm_auth0_auth0-angular_2_2_3__angular_common_22_1_7__angular_core_22_1_7__angu-95c9430": [
		2649,
		26580,
		31257,
		46552,
		81874
	],
	"node_modules_pnpm_deliverysolutions_shared-models_3_0_0-beta_11_fc25e587a0f248014b3015c5dd7cf-1c084a0": [
		31257,
		36557
	],
	"node_modules_pnpm_deliverysolutions_shared-services_3_0_1-beta_2_396e678cee7028a9a12368ce3a1b-bcb65d1": [
		2649,
		26580,
		31257,
		36557,
		41144,
		46552,
		73150,
		73923,
		81874,
		89778
	],
	"node_modules_pnpm_ngrx_store_22_0_1__angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_8_2_-ae85880": [
		26580,
		31257,
		46552,
		62333
	],
	"node_modules_pnpm_angular_common_22_1_7__angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_-f24fa01": [
		26580
	],
	"node_modules_pnpm_angular_common_22_1_7__angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_-e947c31": [
		26580,
		46552
	],
	"node_modules_pnpm_angular_router_22_1_7__angular_common_22_1_7__angular_core_22_1_7__angular_-5036dc1": [
		26580,
		41144,
		46552
	],
	"node_modules_pnpm_ngrx_store_22_0_1__angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_8_2_-ae85881": [
		26580,
		46552,
		62333
	],
	"node_modules_pnpm_deliverysolutions_shared-models_3_0_0-beta_11_fc25e587a0f248014b3015c5dd7cf-1c084a1": [
		36557
	],
	"node_modules_pnpm_angular_core_22_1_7__angular_compiler_22_1_7_rxjs_7_8_2_zone_js_0_16_3_node-b66ca31": [
		1469,
		41861
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}